var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flew-row"},[_c('div',{staticClass:"flex-1"},[_c('Reklamationsgrund')],1),_c('div',{staticClass:"flex-1 ml-5"},[_c('Reklamationsstatus')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }